import { render, staticRenderFns } from "./Q_A.vue?vue&type=template&id=1e3098f1&"
import script from "./Q_A.vue?vue&type=script&lang=js&"
export * from "./Q_A.vue?vue&type=script&lang=js&"
import style0 from "./Q_A.vue?vue&type=style&index=0&id=1e3098f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports